<template>
  <div class="info-block" :class="bg === 1 ? 'bg1' : 'bg2'">
    <div class="col col-1">
      <div class="name">{{ name }}</div>
      <div class="value">{{ value }}</div>
    </div>
    <div class="col col-2">
      <div class="unit">{{ unit }}</div>
    </div>
    <div class="col col-3">
      <div>
        <AlarmLevelBar :state="state" />
      </div>
    </div>
  </div>
</template>

<script>
import AlarmLevelBar from './AlarmLevelBar.vue';
export default {
  components: { AlarmLevelBar },
  props: {
    bg: {
      type: Number,
      default: 1
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    unit: {
      type: String,
      default: ''
    },
    state: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
.info-block {
  display: flex;
  padding: 0 30px;

  .col {
    font-size: 3em;
    padding: 15px 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .col-1 {
    flex: 1;
  }
  .col-2 {
    flex: 1;
    justify-content: flex-end;
  }
  .col-3 {
    flex: 2;
    justify-content: flex-end;
  }

  &.bg1 {
    background: #0f2f80;
  }

  &.bg2 {
    background: linear-gradient(120deg, #0f2f80 90%, transparent 80% 100%);
  }
}
</style>
